import styled from '@emotion/styled';

const LiveSelectBoxes = styled('div')({
  height: '4.5rem',
  marginBottom: '1.5rem',
});

export default LiveSelectBoxes;
